import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colorPalette } from '@qualifio/ui-commons';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { IconHelper, IconHelperProps } from '../../helpers/IconHelper';

export interface EditorSidebarHeaderProps {
  icon?: IconHelperProps['icon'];
  title: string;
  onClose?: () => void;
}

export function EditorSidebarHeader({
  icon,
  title,
  onClose,
}: EditorSidebarHeaderProps): React.ReactElement {
  return (
    <Box
      sx={{
        flexGrow: 0,
        flexShrink: 0,
        height: 48,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: 16,
        fontWeight: 600,
        borderBottom: `1px solid ${colorPalette.grey.main}`,
        paddingLeft: 2,
        color: colorPalette.marine.main,
      }}
    >
      {<IconHelper icon={icon} fixedWidth />}
      <Typography
        variant="h2"
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          margin: 0,
          marginLeft: icon ? 1 : undefined,
          fontSize: 14,
        }}
      >
        {title}
      </Typography>
      {onClose && (
        <IconButton
          onClick={onClose}
          sx={{
            flexGrow: 0,
            flexShrink: 0,
            margin: 0,
            fontSize: 16,
            fontWeight: 400,
            color: colorPalette.grey.mainHover,
            backgroundColor: colorPalette.white.main,
            '&:hover': {
              backgroundColor: colorPalette.white.main,
              color: colorPalette.grey.darkHover,
            },
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      )}
    </Box>
  );
}
